(() => {
    const root = document.getElementById('rd-radio');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const readJson = (id, fallback) => {
      try {
        const node = document.getElementById(id);
        if (!node) return fallback;
        const parsed = JSON.parse(node.textContent || '');
        return Array.isArray(parsed) ? parsed : fallback;
      } catch (_) {
        return fallback;
      }
    };

    const fallbackStations = [
      { id: 'main-hall', name: 'Main Hall', theme: 'main-hall', isDefault: true, sortOrder: 10 }
    ];

    const fallbackTracks = [
      {
        id: 'roll-the-dice',
        title: 'Roll the Dice',
        artist: 'Riski Dice',
        bardKey: 'riski-dice',
        src: 'https://cdn.shopify.com/s/files/1/0813/4731/3979/files/Roll_The_Dice.mp3?v=1789242647',
        artistUrl: '',
        stations: ['main-hall'],
        genres: ['fantasy', 'folk'],
        moods: ['adventure', 'tavern'],
        status: 'catalog',
        featuredWeight: 1,
        sponsored: false
      },
      {
        id: 'riski-dice',
        title: 'Riski Dice',
        artist: 'Riski Dice',
        bardKey: 'riski-dice',
        src: 'https://cdn.shopify.com/s/files/1/0813/4731/3979/files/Riski_Dice.mp3?v=1789242647',
        artistUrl: '',
        stations: ['main-hall'],
        genres: ['fantasy', 'theme'],
        moods: ['adventure', 'anthem'],
        status: 'catalog',
        featuredWeight: 1,
        sponsored: false
      }
    ];

    let stations = readJson('rd-radio-station-data', fallbackStations)
      .filter((station) => station && station.id && station.name)
      .sort((a, b) => Number(a.sortOrder || 999) - Number(b.sortOrder || 999));

    let tracks = readJson('rd-radio-track-data', fallbackTracks)
      .filter((track) => track && track.id && track.src)
      .map((track) => ({
        ...track,
        stations: Array.isArray(track.stations) && track.stations.length ? track.stations : ['main-hall'],
        status: String(track.status || 'catalog').toLowerCase(),
        featuredWeight: Number(track.featuredWeight || 1),
        sponsored: Boolean(track.sponsored)
      }));

    if (!stations.length) stations = fallbackStations;
    if (!tracks.length) tracks = fallbackTracks;

    const audio = root.querySelector('#rd-radio-audio');
    const playButton = root.querySelector('.rd-radio__play');
    const previousButton = root.querySelector('.rd-radio__previous');
    const nextButton = root.querySelector('.rd-radio__next');
    const collapseButton = root.querySelector('.rd-radio__collapse');
    const restoreButton = root.querySelector('.rd-radio__restore');
    const restoreIcon = root.querySelector('.rd-radio__restore-icon');
    const muteButton = root.querySelector('.rd-radio__mute');
    const progress = root.querySelector('.rd-radio__progress');
    const volume = root.querySelector('.rd-radio__volume');
    const currentLabel = root.querySelector('.rd-radio__current');
    const durationLabel = root.querySelector('.rd-radio__duration');
    const trackLabel = root.querySelector('.rd-radio__track');
    const artistLabel = root.querySelector('.rd-radio__artist');
    const bardLink = root.querySelector('.rd-radio__bard-link');
    const badge = root.querySelector('.rd-radio__badge');
    const countLabel = root.querySelector('.rd-radio__count');
    const status = root.querySelector('.rd-radio__status');
    const stationWrap = root.querySelector('.rd-radio__station-wrap');
    const stationSelect = root.querySelector('.rd-radio__station');

    const sessionKeys = {
      track: 'riskiDiceRadio.trackHandle',
      time: 'riskiDiceRadio.time',
      playing: 'riskiDiceRadio.playing',
      deck: 'riskiDiceRadio.deck',
      recentBards: 'riskiDiceRadio.recentBards',
      history: 'riskiDiceRadio.history'
    };

    const localKeys = {
      volume: 'riskiDiceRadio.volume',
      collapsed: 'riskiDiceRadio.collapsed',
      station: 'riskiDiceRadio.station'
    };

    const safeGet = (storage, key, fallback = null) => {
      try {
        const value = storage.getItem(key);
        return value === null ? fallback : value;
      } catch (_) {
        return fallback;
      }
    };

    const safeSet = (storage, key, value) => {
      try {
        storage.setItem(key, String(value));
      } catch (_) {}
    };

    const safeGetArray = (storage, key) => {
      try {
        const value = JSON.parse(safeGet(storage, key, '[]'));
        return Array.isArray(value) ? value : [];
      } catch (_) {
        return [];
      }
    };

    const safeSetArray = (storage, key, value) => {
      safeSet(storage, key, JSON.stringify(Array.isArray(value) ? value : []));
    };

    const defaultStation = stations.find((station) => station.isDefault) || stations[0];
    let stationId = safeGet(localStorage, localKeys.station, defaultStation.id);
    if (!stations.some((station) => station.id === stationId)) stationId = defaultStation.id;

    let currentHandle = null;
    let pendingSeek = 0;
    let pendingAutoplay = false;
    let lastNonZeroVolume = 0.35;
    let lastSavedSecond = -1;
    let deck = safeGetArray(sessionStorage, sessionKeys.deck);
    let recentBards = safeGetArray(sessionStorage, sessionKeys.recentBards);
    let playHistory = safeGetArray(sessionStorage, sessionKeys.history);

    const getStation = () => stations.find((station) => station.id === stationId) || defaultStation;
    const getTrack = (handle) => tracks.find((track) => track.id === handle) || null;
    const getPool = () => tracks.filter((track) => track.stations.includes(stationId));

    const formatTime = (seconds) => {
      if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${String(secs).padStart(2, '0')}`;
    };

    const paintRange = (input, fraction) => {
      const pct = Math.max(0, Math.min(100, fraction * 100));
      const active = root.classList.contains('has-active-residency');
      const fill = active ? '#d6b44c' : 'var(--rd-accent)';
      input.style.background = `linear-gradient(90deg, ${fill} 0%, ${fill} ${pct}%, rgba(245,242,234,.24) ${pct}%, rgba(245,242,234,.24) 100%)`;
    };

    const shuffle = (items) => {
      const copy = [...items];
      for (let i = copy.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }
      return copy;
    };

    const saveQueueState = () => {
      safeSetArray(sessionStorage, sessionKeys.deck, deck);
      safeSetArray(sessionStorage, sessionKeys.recentBards, recentBards);
      safeSetArray(sessionStorage, sessionKeys.history, playHistory);
    };

    const resetQueueState = () => {
      deck = [];
      recentBards = [];
      playHistory = [];
      saveQueueState();
    };

    const buildDeck = () => {
      const pool = getPool();
      const weighted = [];

      pool.forEach((track) => {
        const repeatCount = track.status === 'active'
          ? Math.max(2, Math.min(3, Math.round(track.featuredWeight || 2)))
          : 1;

        for (let i = 0; i < repeatCount; i += 1) weighted.push(track.id);
      });

      deck = shuffle(weighted);
      safeSetArray(sessionStorage, sessionKeys.deck, deck);
    };

    const drawNextHandle = () => {
      const pool = getPool();
      if (!pool.length) return null;
      if (pool.length === 1) return pool[0].id;

      const validHandles = new Set(pool.map((track) => track.id));
      deck = deck.filter((handle) => validHandles.has(handle));
      if (!deck.length) buildDeck();

      const recent = recentBards.slice(-2);
      let index = deck.findIndex((handle) => {
        const track = getTrack(handle);
        return track && handle !== currentHandle && !recent.includes(track.bardKey);
      });

      if (index < 0) {
        index = deck.findIndex((handle) => handle !== currentHandle);
      }

      if (index < 0) index = 0;

      const [handle] = deck.splice(index, 1);
      safeSetArray(sessionStorage, sessionKeys.deck, deck);
      return handle;
    };

    const noteTrack = (track) => {
      if (!track) return;

      if (track.bardKey) {
        recentBards.push(track.bardKey);
        recentBards = recentBards.slice(-3);
      }

      if (playHistory[playHistory.length - 1] !== track.id) {
        playHistory.push(track.id);
        playHistory = playHistory.slice(-20);
      }

      saveQueueState();
    };

    const stationIcon = (theme) => {
      const icons = {
        tavern: '♬',
        hearth: '♨',
        battlefield: '⚔',
        arcane: '✦',
        adventure: '⌖',
        'main-hall': '♪'
      };
      return icons[theme] || '♪';
    };

    const applyStationTheme = () => {
      const station = getStation();
      const theme = String(station.theme || 'main-hall').toLowerCase();
      root.dataset.stationTheme = theme;
      restoreIcon.textContent = stationIcon(theme);
      stationSelect.value = station.id;
    };

    const populateStations = () => {
      stationSelect.innerHTML = '';
      stations.forEach((station) => {
        const option = document.createElement('option');
        option.value = station.id;
        option.textContent = station.name;
        stationSelect.appendChild(option);
      });
      stationWrap.hidden = stations.length <= 1;
      stationSelect.value = stationId;
    };

    const ensureStationHasTracks = () => {
      if (getPool().length) return true;
      if (stationId !== defaultStation.id) {
        stationId = defaultStation.id;
        safeSet(localStorage, localKeys.station, stationId);
        applyStationTheme();
        stationSelect.value = stationId;
      }
      return getPool().length > 0;
    };

    const updateTrackUI = () => {
      const track = getTrack(currentHandle);
      const pool = getPool();

      if (!track) {
        trackLabel.textContent = 'Riski Dice Radio';
        artistLabel.textContent = '';
        bardLink.hidden = true;
        badge.hidden = true;
        countLabel.textContent = '';
        root.classList.remove('has-active-residency');
        return;
      }

      const isActive = track.status === 'active';
      root.classList.toggle('has-active-residency', isActive);
      trackLabel.textContent = track.title;
      artistLabel.textContent = track.artist || '';
      countLabel.textContent = `${pool.length} track${pool.length === 1 ? '' : 's'}`;

      if (track.artistUrl) {
        bardLink.href = track.artistUrl;
        bardLink.hidden = false;
      } else {
        bardLink.hidden = true;
      }

      if (isActive) {
        badge.textContent = track.sponsored ? 'Sponsored Bard' : 'Featured';
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }

      previousButton.disabled = playHistory.length < 2;
      previousButton.style.opacity = previousButton.disabled ? '0.35' : '';
      nextButton.setAttribute('aria-label', `Skip ${track.title}`);
      playButton.setAttribute('aria-label', audio.paused ? `Play ${track.title}` : `Pause ${track.title}`);
      paintRange(progress, Number(progress.value) / 1000);
      paintRange(volume, Number(volume.value));
    };

    const updatePlayUI = () => {
      const playing = !audio.paused && !audio.ended;
      root.classList.toggle('is-playing', playing);
      const track = getTrack(currentHandle);
      playButton.setAttribute('aria-label', playing ? `Pause ${track?.title || 'music'}` : `Play ${track?.title || 'music'}`);
      playButton.title = playing ? 'Pause' : 'Play';
    };

    const updateVolumeUI = () => {
      const muted = audio.muted || audio.volume === 0;
      root.classList.toggle('is-muted', muted);
      muteButton.setAttribute('aria-label', muted ? 'Unmute music' : 'Mute music');
      muteButton.title = muted ? 'Unmute' : 'Mute';
      volume.value = muted ? 0 : audio.volume;
      paintRange(volume, Number(volume.value));
    };

    const updateProgressUI = () => {
      const duration = Number.isFinite(audio.duration) && audio.duration > 0 ? audio.duration : 0;
      const fraction = duration ? audio.currentTime / duration : 0;
      progress.value = Math.round(fraction * 1000);
      paintRange(progress, fraction);
      currentLabel.textContent = formatTime(audio.currentTime);
      durationLabel.textContent = duration ? formatTime(duration) : '0:00';
    };

    const savePosition = () => {
      if (currentHandle) safeSet(sessionStorage, sessionKeys.track, currentHandle);
      safeSet(sessionStorage, sessionKeys.time, audio.currentTime || 0);
    };

    const requestPlay = async () => {
      status.textContent = '';
      try {
        await audio.play();
        safeSet(sessionStorage, sessionKeys.playing, 'true');
      } catch (_) {
        safeSet(sessionStorage, sessionKeys.playing, 'true');
        status.textContent = 'Tap ▶ to continue';
      }
      updatePlayUI();
    };

    const pauseByChoice = () => {
      audio.pause();
      safeSet(sessionStorage, sessionKeys.playing, 'false');
      status.textContent = '';
      updatePlayUI();
    };

    const loadTrack = (handle, options = {}) => {
      const pool = getPool();
      const fallback = pool[0] || tracks[0];
      const track = getTrack(handle) || fallback;
      if (!track) return;

      currentHandle = track.id;
      pendingSeek = Math.max(0, Number(options.restoreTime) || 0);
      pendingAutoplay = options.autoplay === true;
      lastSavedSecond = -1;

      safeSet(sessionStorage, sessionKeys.track, currentHandle);
      safeSet(sessionStorage, sessionKeys.time, pendingSeek);
      safeSet(sessionStorage, sessionKeys.playing, pendingAutoplay ? 'true' : 'false');

      if (options.recordHistory !== false) noteTrack(track);

      status.textContent = '';
      audio.src = track.src;
      updateTrackUI();
      updatePlayUI();
      currentLabel.textContent = '0:00';
      durationLabel.textContent = '0:00';
      progress.value = 0;
      paintRange(progress, 0);
      audio.load();
    };

    const goNext = (autoplay) => {
      const nextHandle = drawNextHandle();
      if (nextHandle) loadTrack(nextHandle, { autoplay, restoreTime: 0 });
    };

    const goPrevious = () => {
      if (playHistory.length < 2) return;
      const keepPlaying = !audio.paused && !audio.ended;
      playHistory.pop();
      const previousHandle = playHistory.pop();
      saveQueueState();

      const previous = getTrack(previousHandle);
      if (!previous || !previous.stations.includes(stationId)) return;
      loadTrack(previousHandle, { autoplay: keepPlaying, restoreTime: 0, recordHistory: true });
    };

    const savedVolume = parseFloat(safeGet(localStorage, localKeys.volume, '0.35'));
    audio.volume = Number.isFinite(savedVolume) ? Math.max(0, Math.min(1, savedVolume)) : 0.35;
    if (audio.volume > 0) lastNonZeroVolume = audio.volume;
    volume.value = audio.volume;

    const collapsed = safeGet(localStorage, localKeys.collapsed, 'false') === 'true';
    root.classList.toggle('is-collapsed', collapsed);

    populateStations();
    applyStationTheme();
    ensureStationHasTracks();
    updateVolumeUI();

    stationSelect.addEventListener('change', () => {
      const nextStation = stationSelect.value;
      if (!stations.some((station) => station.id === nextStation)) return;

      const keepPlaying = !audio.paused && !audio.ended;
      stationId = nextStation;
      safeSet(localStorage, localKeys.station, stationId);
      resetQueueState();
      applyStationTheme();

      if (!ensureStationHasTracks()) {
        status.textContent = 'No tracks available';
        return;
      }

      const current = getTrack(currentHandle);
      if (current && current.stations.includes(stationId)) {
        noteTrack(current);
        updateTrackUI();
        status.textContent = `Tuned to ${getStation().name}`;
        return;
      }

      status.textContent = `Tuned to ${getStation().name}`;
      goNext(keepPlaying);
    });

    audio.addEventListener('loadedmetadata', async () => {
      if (pendingSeek > 0 && pendingSeek < audio.duration - 0.5) {
        audio.currentTime = pendingSeek;
      }
      pendingSeek = 0;
      updateProgressUI();

      if (pendingAutoplay) {
        pendingAutoplay = false;
        await requestPlay();
      }
    });

    audio.addEventListener('play', () => {
      safeSet(sessionStorage, sessionKeys.playing, 'true');
      status.textContent = '';
      updatePlayUI();
    });

    audio.addEventListener('pause', updatePlayUI);

    audio.addEventListener('timeupdate', () => {
      updateProgressUI();
      const second = Math.floor(audio.currentTime);
      if (second !== lastSavedSecond) {
        lastSavedSecond = second;
        savePosition();
      }
    });

    audio.addEventListener('ended', () => {
      safeSet(sessionStorage, sessionKeys.time, '0');
      goNext(true);
    });

    audio.addEventListener('error', () => {
      status.textContent = 'Track unavailable';
      safeSet(sessionStorage, sessionKeys.playing, 'false');
      root.classList.remove('is-playing');
    });

    playButton.addEventListener('click', () => {
      if (audio.paused || audio.ended) requestPlay();
      else pauseByChoice();
    });

    previousButton.addEventListener('click', goPrevious);
    nextButton.addEventListener('click', () => goNext(!audio.paused && !audio.ended));

    progress.addEventListener('input', () => {
      if (!Number.isFinite(audio.duration) || audio.duration <= 0) return;
      audio.currentTime = (Number(progress.value) / 1000) * audio.duration;
      savePosition();
      updateProgressUI();
    });

    volume.addEventListener('input', () => {
      const value = Math.max(0, Math.min(1, Number(volume.value)));
      audio.muted = false;
      audio.volume = value;
      if (value > 0) lastNonZeroVolume = value;
      safeSet(localStorage, localKeys.volume, value);
      updateVolumeUI();
    });

    muteButton.addEventListener('click', () => {
      if (audio.muted || audio.volume === 0) {
        audio.muted = false;
        audio.volume = lastNonZeroVolume || 0.35;
      } else {
        lastNonZeroVolume = audio.volume;
        audio.muted = true;
      }
      updateVolumeUI();
    });

    collapseButton.addEventListener('click', () => {
      root.classList.add('is-collapsed');
      safeSet(localStorage, localKeys.collapsed, 'true');
      restoreButton.focus();
    });

    restoreButton.addEventListener('click', () => {
      root.classList.remove('is-collapsed');
      safeSet(localStorage, localKeys.collapsed, 'false');
      playButton.focus();
    });

    window.addEventListener('pagehide', () => {
      savePosition();
      saveQueueState();
      safeSet(sessionStorage, sessionKeys.playing, (!audio.paused && !audio.ended) ? 'true' : 'false');
      safeSet(localStorage, localKeys.volume, audio.volume);
      safeSet(localStorage, localKeys.station, stationId);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') savePosition();
    });

    const savedHandle = safeGet(sessionStorage, sessionKeys.track, '');
    const savedTime = parseFloat(safeGet(sessionStorage, sessionKeys.time, '0'));
    const savedPlaying = safeGet(sessionStorage, sessionKeys.playing, 'false') === 'true';
    const savedTrack = getTrack(savedHandle);
    const canRestore = savedTrack && savedTrack.stations.includes(stationId);
    const initialHandle = canRestore ? savedTrack.id : drawNextHandle();

    loadTrack(initialHandle, {
      restoreTime: canRestore && Number.isFinite(savedTime) ? savedTime : 0,
      autoplay: savedPlaying
    });
  })();
